export default __webpack_public_path__ + "edf76edb065d924518be416a33c894bd.png";